import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { NewsSearchTableView } from "../shared/views/news-search-table.view";
import { SecurityGroupSecurityModel } from "src/app/core/models/security-model/security-group-security.model";
import { DxDataGridComponent } from "devextreme-angular";
import { StatusReferenceModel } from "src/app/core/models/reference-model/reference-general-model";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { NewsService } from "src/app/core/services/system-services/news-service";
@Component({
    selector: 'op-news-search-table',
    templateUrl: './news-search-table.component.html',
})
export class NewsSearchTableComponent  implements AfterViewInit, OnChanges {
    public blurAfterSelected: boolean = true;
    public printFlag = false;
    public copyToClipboardFlag = true;
    public exportFlag = false;

    public collapsed: boolean;
    public focused: boolean;
    public showCopyPopover = false;
    public showExportPopover = false;
    public showPrintPopover = false;
    public rows = 0;
    public dataSourceStorage: any;
    
    showHeaderFilter: boolean = true;
    selectedItem: boolean = false;
    applyFilterTypes: any;
    currentFilter: any;
    itemSelected: any;
    exportData: any;
    header: string[];
    pdfDefaultStyle = {
        fontSize: 7
    };
    
    @Input() statusReferences: StatusReferenceModel[];
    @Input() newsSearchResults: NewsSearchTableView[];
    @Input() userSecurity: SecurityGroupSecurityModel;
    @Input() actionSecurity: SecurityGroupSecurityModel;
    @Output() onNew = new EventEmitter();
    @Output() onEdit = new EventEmitter<NewsSearchTableView>();
    @Output() onCopy = new EventEmitter<NewsSearchTableView>();
    @Output() onUpdateStatus = new EventEmitter();

    @ViewChild('dataGridSearch', { static: false }) dataGrid: DxDataGridComponent;

    constructor(private newsService: NewsService,
        public spinnerService: LoadingSpinnerService,
        private ref: ChangeDetectorRef) {
        this.setExportBtnFlag();
    }

    ngAfterViewInit(): void {
        this.setExportBtnFlag();
        this.getDataGridHeader();
    }

    private getDataGridHeader() {
        this.header = this.dataGrid.instance.getVisibleColumns().filter(x => x.caption).map(item => item.caption);
    }


    private setExportBtnFlag() {
        this.printFlag = this.actionSecurity?.printFlag;
        this.copyToClipboardFlag = this.actionSecurity?.copyToClipboardFlag;
        this.exportFlag = this.actionSecurity?.exportFlag;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['actionSecurity']) {
            this.setExportBtnFlag();
        }
    }

    selectedRow(e) {
        this.selectedItem = true;
        this.itemSelected = e.data;
    }

    public getNumberOfRows(e) {
        this.rows = e.component.totalCount();
        this.getExportData()?.done((filteredData) => {
            this.exportData = this.mapExportData(filteredData);
        });
        this.ref.detectChanges();
    }

    private getExportData() {
        let filterExpr = this.dataGrid.instance.getCombinedFilter();
        let gridDataSource = this.dataGrid.instance.getDataSource();
        return gridDataSource?.store()?.load({
            filter: filterExpr
        });  
    }

    public mapExportData(filteredData) {
        return filteredData.map(dat => (
            {
                No: dat.no,
                Title: dat.newsTitle,
                Type: dat.newsTypeCode,
                Priority: dat.newsPriorityCode,
                ValidFrom: dat.validDateFrom,
                ValidTo: dat.validDateTo,
                CommitBy: dat.commitByName ?? '',
                CommitDateTime: dat.commitDateTime ?? '',
                Status: this.getStatusName(dat.statusCode)
            }
        ));
    }

    private getStatusName(statusCode: string): string {
        return this.statusReferences.filter((dat) => dat.statusCode == statusCode)[0]?.displayName;
    }

    public refreshTable() {
        this.dataGrid.instance.refresh();
    }

    updateStatus(data: any, e: any) {
        this.spinnerService.showSaving();
        this.newsService.updateStatus(data.newsId, e)
            .subscribe(
                () => {
                    data.statusCode = e;
                    this.ref.detectChanges();
                    this.spinnerService.saveComplete();
                    this.onUpdateStatus.emit();
                },
                () => {
                    this.spinnerService.hide();
                }      
            );
    }

    newItem() {
        this.onNew.emit();
    }

    editItem() {
        if (this.selectedItem) {
            this.onEdit.emit(this.itemSelected);
        }
    }

    copyItem() {
        if (this.selectedItem) {
            this.onCopy.emit(this.itemSelected);
        }
    }

    doubleClick() {
        this.editItem();
    }

    public getDetail(newsId: string) {
      return this.newsSearchResults.filter(x=>x.newsId == newsId);     
    }
}